import React, { useState, useEffect } from 'react'
import LoadingUI from '../../common/LoadingUI'
import { Box, Card, Grid, IconButton, Stack, Typography } from '@mui/material'
import CachedIcon from '@mui/icons-material/Cached';
import { jwtDecode } from "jwt-decode";

import { useDispatch, useSelector } from 'react-redux';
import { publisherPayoutAction } from '../../redux/toolkit/dashboard/publisherPayout'

const TotalPublisherPayout = () => {

    const dispatch = useDispatch();
    const dashboard = useSelector(state => state.publisherPayout)
    const { message, data, status, loading } = dashboard

    const handleMissionAttemptRefresh = async () => {
        dispatch(publisherPayoutAction())
    }

    // useEffect
    useEffect(() => {
        dispatch(publisherPayoutAction())
    }, [dispatch])

    return (
        <>
          <Card elevation={0} sx={{ p: 2, height: "116px" , borderRadius:"11px" , position:"relative", background: "rgba(254, 206, 113, 0.16)"}}>
               
<Stack direction={'row'} position={"absolute"} bottom={10} left={10} justifyContent='space-between'>
                    {/* Publisher total payout */}
                    <Typography variant='p'>Total Revenue $</Typography>
                    {/* <IconButton onClick={handleMissionAttemptRefresh}><CachedIcon /></IconButton> */}
                </Stack>
                {loading
                    ? <LoadingUI justifyContent='flex-start' />
                    : <Typography fontSize={{
                        xs: "22px",
                        sm: "30px",
                        md: "30px",
                        lg: "30px",
                        xl: "30px",
                      }} fontWeight={700} color='#071D45' variant='h4'>{data?.total_earning ?`${ Number(data?.total_earning)?.toFixed(2) } `: '--'}</Typography>}

            </Card>
        </>
    )
}

export default TotalPublisherPayout
